export default __webpack_public_path__ + "static/media/hol-hspromo-580x400.fc6cfaa6.png";